export default __webpack_public_path__ + "static/media/raal.fd2e5302.png";